import buildBaseConfig from './blaze.config.base';
// The project/ dir is copied by bin/prepare-application.sh — run
// `npm run dev:[PROJECT_KEY]` (or the deploy prepare step) first.
import buildProjectConfig from './project/blaze.config';

export default function buildConfig(config) {
  return buildProjectConfig(buildBaseConfig(config));
}
